import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from hash
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found in URL');
        navigate('/login', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for user data + JWT token
        const response = await axios.post(`${API}/auth/session?session_id=${sessionId}`, {}, {
          withCredentials: true
        });
        
        const userData = response.data;
        
        // Store JWT token for API calls
        if (userData.access_token) {
          localStorage.setItem('token', userData.access_token);
        }
        
        setUser(userData);
        
        // Navigate to appropriate dashboard based on role
        const roleDashboards = {
          admin: '/admin',
          agent: '/agent',
          donor: '/donor'
        };
        const redirectPath = roleDashboards[userData.role] || '/donor';
        
        // Clear the hash and navigate
        window.history.replaceState(null, '', window.location.pathname);
        navigate(redirectPath, { replace: true, state: { user: userData } });
        
      } catch (error) {
        console.error('Failed to exchange session:', error);
        const detail = error.response?.data?.detail || 'Authentication failed';
        navigate('/login', { replace: true, state: { error: detail } });
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="spinner mx-auto mb-4"></div>
        <p className="text-slate-600">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
